import { faSatellite } from '@fortawesome/free-solid-svg-icons';

import { Button, Icon } from 'apps/shared/scripts/components';

import { ContentCard } from '../Content';

import {
  actionClassName,
  bodyClassName,
  buttonClassName,
  descriptionClassName,
  emptyClassName,
  iconClassName,
  mediaClassName,
} from './styles';

interface Props {
  ctaLabel?: string;
  ctaOnClick?: () => void;
  description: string;
}

const Empty = ({ ctaLabel, ctaOnClick, description }: Props) => {
  return (
    <ContentCard>
      <div className={emptyClassName}>
        <div className={mediaClassName}>
          <Icon className={iconClassName} fa={faSatellite} />
        </div>
        <div className={bodyClassName}>
          <span className={descriptionClassName}>{description}</span>
        </div>
        {ctaLabel && ctaOnClick && (
          <div className={actionClassName}>
            <Button className={buttonClassName} onClick={ctaOnClick}>
              {ctaLabel}
            </Button>
          </div>
        )}
      </div>
    </ContentCard>
  );
};

Empty.displayName = 'Empty';

export default Empty;
